import Header from "../../components/seller-hub/header/Header";
import Seller from "../../layouts/seller-hub/Seller";
import DropDown from "../../components/seller-hub/wallet/DropDown";
import Button from "../../components/seller-hub/buttons/Button";
import Table from "../../components/seller-hub/inventory-manager/Table";
import TableRow from "../../components/seller-hub/inventory-manager/TableRow";
import Pagination from "../../components/seller-hub/pagination/Pagination";

const SellerInventory = () => {
  const dummyArr = [
    {
      itemId: "110009",
      name: "Kimono Japan",
      availabilityStatus: "Available",
      itemStatus: "In cart",
    },
    {
      itemId: "110009",
      name: "Kimono Japan",
      availabilityStatus: "Not available",
      itemStatus: "In cart",
    },
    {
      itemId: "110009",
      name: "Kimono Japan",
      availabilityStatus: "Available",
      itemStatus: "In cart",
    },
  ];
  return (
    <div className="-mt-20 w-full pb-5">
      <Header />
      <Seller>
        <div className="mt-5">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center">
            <DropDown
              additionalClass="h-[44px]"
              icon={[
                <svg
                  key={Math.random()}
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-chevron-down"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                  />
                </svg>,
              ]}
              innerText="Select"
            />
            <div className="flex mt-3 md:mt-0 flex-col md:flex-row gap-4 items-start md:items-center">
              <DropDown
                additionalClass="h-[44px]"
                icon={[
                  <svg
                    key={Math.random()}
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-chevron-down"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                    />
                  </svg>,
                ]}
                innerText="Filter by status"
              />
              <DropDown
                additionalClass="h-[44px]"
                icon={[
                  <svg
                    key={Math.random()}
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-chevron-down"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                    />
                  </svg>,
                ]}
                innerText="Filter by availability"
              />
              <Button
                width="w-[133px]"
                icon={[
                  <svg
                    key={Math.random()}
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-file-earmark-minus"
                    viewBox="0 0 16 16"
                  >
                    <path d="M5.5 9a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5z" />
                    <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z" />
                  </svg>,
                ]}
                innerText="Download"
              />
            </div>
          </div>

          <div className="mt-8 pt-2 border-t-[0.5px] border-l-[0.5px] border-r-[0.5px] rounded-tr rounded-tl border-[#DEE2F3] ">
            <h4 className="text-lg font-Lato font-bold pl-2">
              Inventory Manager
            </h4>
            <div className="overflow-scroll xl:overflow-auto scrollbar-none">
              <div className="w-[820px] xl:w-auto">
                <div className="mt-3 pl-2">
                  <Table />
                </div>
                <div className="">
                  {dummyArr.map((arr, index) => (
                    <TableRow key={Math.random()} data={arr} index={index} />
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="h-[72px] flex justify-between items-center pl-2 pr-2 border-[0.5px] rounded-bl rounded-br border-[#DEE2F3]">
            <p className="text-sm text-[#757575]">Page 1 to 10</p>
            <Pagination />
          </div>
          <div className="flex justify-end mt-5">
            <Button
              width="w-[129px]"
              innerText="New Item"
              icon={[
                <svg
                  key={Math.random()}
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-plus-square w-6 h-6"
                  viewBox="0 0 16 16"
                >
                  <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" />
                  <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                </svg>,
              ]}
            />
          </div>
        </div>
      </Seller>
    </div>
  );
};

export default SellerInventory;
